import { jwtDecode } from "jwt-decode";
import * as Constants from '../constants';
import CryptoJS from 'crypto-js';
import environment from "../environments/environment";
import ENDPOINTS from "../ApiManager/AuthenticationEndpoints";

const BASE_URL = environment.api_url;

export class AuthenticationService {
	
	static oauthToken = (username, password) => {
		const url = BASE_URL + ENDPOINTS.OAUTH_TOKEN(username, password);
		return fetch(url, {
			method: 'POST'
		});
	};
	
	handleAuthenticationData(data, i18n) {

		 const decodedToken = jwtDecode(data.access_token);
					 
		 const authentication = {
	        token: data,
	        user: null,
	        user_name: decodedToken.user_name,
	        roles: decodedToken.authorities,
	        locale: i18n.language
	     };
	     
	     if (decodedToken.administrador != null) {
	        authentication.user = decodedToken.administrador;
	     }
	     
	     if (decodedToken.admincadena != null) {
	        authentication.user = decodedToken.admincadena;
	     }
		 
		 if (decodedToken.gestor != null) {
	        authentication.user = decodedToken.gestor;
	     }
	     
	     if (decodedToken.trabajador != null) {
	        authentication.user = decodedToken.trabajador;
	     }
	     
	     this.setAuthenticationSession(authentication);
	}
	
	getAuthenticationSession() {
	    try {
	      const authentication = localStorage.getItem(Constants.SESSION_AUTHENTICATION_KEY);
	      if (authentication == null) {
	        return null;
	      }
	
	      return JSON.parse(CryptoJS.AES.decrypt(authentication, environment.session_encrypt_key).toString(CryptoJS.enc.Utf8));
	    } catch(error) {
	      console.error(error);
	    }
	
	    return null;
  	}

  	setAuthenticationSession(authentication) {
	    try {
	      if (authentication !== null) {
	        const authentication_encrypt = CryptoJS.AES.encrypt(JSON.stringify(authentication), environment.session_encrypt_key).toString();
	        localStorage.setItem(Constants.SESSION_AUTHENTICATION_KEY, authentication_encrypt);
	      } else {
	        localStorage.removeItem(Constants.SESSION_AUTHENTICATION_KEY);
	      }
	    } catch(error) {
	      console.error(error);
	    }
  	}
  	
  	isUserLogged() {
		const authentication = this.getAuthenticationSession();
    	return authentication != null && authentication.token != null;
  	}
  	
  	logout() {
	    this.setAuthenticationSession(null);
	}
	
}